import type { Theme } from '../types/theme';
import {
  claudeTheme,
  linearTheme,
  vercelTheme,
  stripeTheme,
  notionTheme,
  supabaseTheme,
  appleTheme,
  airbnbTheme,
  cursorTheme,
  spotifyTheme,
  nvidiaTheme,
  raycastTheme,
  posthogTheme,
  intercomTheme,
  figmaTheme,
  framerTheme,
  teslaTheme,
  slackTheme,
  cohereTheme,
  clickhouseTheme,
  mongodbTheme,
  sanityTheme,
  calTheme,
  mintlifyTheme,
  resendTheme,
  zapierTheme,
  airtableTheme,
  miroTheme,
  webflowTheme,
  binanceTheme,
  coinbaseTheme,
  shopifyTheme,
  revolutTheme,
  elevenlabsTheme,
  minimaxTheme,
  mistralTheme,
  ollamaTheme,
  opencodeTheme,
  replicateTheme,
  runwaymlTheme,
  togetherTheme,
  voltagentTheme,
  xaiTheme,
  expoTheme,
  lovableTheme,
  superhumanTheme,
  warpTheme,
  composioTheme,
  hashicorpTheme,
  sentryTheme,
  ibmTheme,
  pinterestTheme,
  playstationTheme,
  spacexTheme,
  vergeTheme,
  uberTheme,
  vodafoneTheme,
  wiredTheme,
  bmwTheme,
  bugattiTheme,
  ferrariTheme,
  lamborghiniTheme,
  renaultTheme,
  azureTheme,
  cloudflareTheme,
  datadogTheme,
  figTheme,
  phindTheme,
} from '../styles/themes';

export const allThemes: Theme[] = [
  claudeTheme,
  linearTheme,
  vercelTheme,
  stripeTheme,
  notionTheme,
  supabaseTheme,
  appleTheme,
  airbnbTheme,
  cursorTheme,
  spotifyTheme,
  nvidiaTheme,
  raycastTheme,
  posthogTheme,
  intercomTheme,
  figmaTheme,
  framerTheme,
  teslaTheme,
  slackTheme,
  cohereTheme,
  clickhouseTheme,
  mongodbTheme,
  sanityTheme,
  calTheme,
  mintlifyTheme,
  resendTheme,
  zapierTheme,
  airtableTheme,
  miroTheme,
  webflowTheme,
  binanceTheme,
  coinbaseTheme,
  shopifyTheme,
  revolutTheme,
  elevenlabsTheme,
  minimaxTheme,
  mistralTheme,
  ollamaTheme,
  opencodeTheme,
  replicateTheme,
  runwaymlTheme,
  togetherTheme,
  voltagentTheme,
  xaiTheme,
  expoTheme,
  lovableTheme,
  superhumanTheme,
  warpTheme,
  composioTheme,
  hashicorpTheme,
  sentryTheme,
  ibmTheme,
  pinterestTheme,
  playstationTheme,
  spacexTheme,
  vergeTheme,
  uberTheme,
  vodafoneTheme,
  wiredTheme,
  bmwTheme,
  bugattiTheme,
  ferrariTheme,
  lamborghiniTheme,
  renaultTheme,
  azureTheme,
  cloudflareTheme,
  datadogTheme,
  figTheme,
  phindTheme,
];

export const themeById = allThemes.reduce((acc, theme) => {
  acc[theme.id] = theme;
  return acc;
}, {} as Record<string, Theme>);
